export default __webpack_public_path__ + "static/media/no-items-found.95fae4ff.png";